module.exports = __webpack_public_path__ + "assets/img/download-btn-88336869.png";